// Come si riassume una copertura: quale tecnologia contare come "la migliore", se la
// verifica e' riuscita, e come si scrive l'esito nella riga di cronologia.
// Modulo a parte perche' e' logica pura, provata dai test: la pagina che lo usa importa
// mezza libreria di mappe (ESM) e non si puo' caricare dentro jest.

// ── Copertura: ricostruzione tecnologia migliore (allineata al file live) ──
export const ESITO_LABEL = { fwa_5g: 'FWA 5G', fwa_4g: 'FWA 4G', fibra_10g: 'Fibra 10G', fibra_nere: 'Fibra nere', fibra_bianche: 'Fibra bianche', xdsl_30m: 'xDSL 30M', xdsl_fast200: 'xDSL Fast 200', adsl_prof: 'ADSL', ftto: 'FTTO', eth_silver: 'Eth. Silver', eth_gold: 'Eth. Gold', fibra_prof_10g: 'Fibra Prof. 10G', fibra_prof: 'Fibra Prof.' };
export const PRIORITA_TECH = ['fibra_10g', 'fibra_prof_10g', 'ftto', 'eth_gold', 'eth_silver', 'fibra_prof', 'fibra_nere', 'fibra_bianche', 'fwa_5g', 'fwa_4g', 'xdsl_fast200', 'xdsl_30m', 'adsl_prof'];
export function colonneDaEsito(esito) {
  const s = (esito || '').toUpperCase(); const col = {};
  Object.keys(ESITO_LABEL).forEach(k => { col[k] = { esito: s.includes(ESITO_LABEL[k].toUpperCase()) ? 'OK' : null }; });
  return col;
}
export function colonneOk(d) {
  const col = (d?.colonne && Object.keys(d.colonne).length) ? d.colonne : colonneDaEsito(d?.esito);
  return PRIORITA_TECH.filter(k => (col[k] || {}).esito === 'OK').map(k => ESITO_LABEL[k]);
}
export function miglioreTecnologia(d) { const ok = colonneOk(d); return ok.length ? ok[0] : 'Nessuna copertura'; }
export function covStato(d) {
  if (d?.errore) return 'errore';
  const e = (d?.esito || '').trim().toLowerCase();
  if (e === 'errore') return 'errore';
  if (d?.trovato === false || e === 'non trovato') return 'nontrovato';
  return 'ok';
}

// ── Copertura dal sito TIM: altro formato di risposta (verdetto + velocità), non la matrice ──
export const fmtVelTim = (v) => (v == null || v === '' ? '' : `${v} Mbit/s`);
export const esitoColorTim = (e) => {
  const s = (e || '').toUpperCase();
  if (s.includes('NON CENS')) return 'var(--faint)';
  if (s.includes('NON')) return 'var(--cvf)';
  if (s.includes('COPERT') || s.includes('OK') || s.includes('DISPONIB')) return 'var(--cnum)';
  return 'var(--ccov)';
};

// esito compatto per la riga di cronologia (esportata: e' coperta dai test)
export function esitoText(d) {
  if (d.tipo === 'dominio') {
    const st = d.step || {};
    const done = ['n456', 'copertura', 'lucchetto'].filter(k => st[k] && (st[k].esito || st[k].stato === 'fatto')).length;
    return `${done}/3`;
  }
  if (d.tipo === 'copertura') {
    const st = covStato(d);
    return st === 'errore' ? 'non riuscita' : st === 'nontrovato' ? 'non trovato' : miglioreTecnologia(d);
  }
  // Copertura dal sito TIM: l'esito e' gia' una parola ('FTTH', 'non trovato', 'errore').
  if (d.tipo === 'coperturatim') return d.esito === 'errore' ? 'non riuscita' : (d.esito || '—');
  if (d.tipo === 'indaga') return (d.dati && d.dati.ragione_sociale) ? d.dati.ragione_sociale : 'nessun risultato';
  // Salvagente: un tipo nuovo il cui `risultato` e' un oggetto non deve poter far sparire
  // la pagina («Objects are not valid as a React child» = schermata bianca).
  return typeof d.risultato === 'string' ? d.risultato : '—';
}
// Esito in cronologia: SOLO scritta colorata (niente sfondo/pillola).
export function esitoStyle(d) {
  if (d.tipo === 'dominio') return { color: 'var(--cdom)' };
  if (d.tipo === 'indaga') return { color: 'var(--c456)' };
  if (d.tipo === 'copertura') return { color: covStato(d) === 'ok' ? 'var(--ccov)' : 'var(--warn)' };
  if (d.tipo === 'coperturatim') return { color: (d.esito && d.esito !== 'errore' && d.esito !== 'non trovato') ? 'var(--ccov)' : 'var(--warn)' };
  if (d.risultato === 'TIM') return { color: 'var(--c456)' };
  if (d.risultato === 'NON TIM') return { color: 'var(--cvf)' };
  return { color: 'var(--muted)' };
}
